import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";

const MarqueFilterComponent = ({ asset, brand, status, ths }) => {
  const [checked, setChecked] = useState(false);
  const [desputeChecked, setDesputeChecked] = useState(false);

  const [show, setShow] = useState(false);

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    console.log(isChecked, "isChecked");
    // Define the value to be sent in the request
    const value = isChecked ? 1 : 0;
    ths.resetMarque(value);
    ths.resetCounter();
  };

  const handleCheckboxDesputeChange = (event) => {
    const isChecked = event.target.checked;
    setDesputeChecked(isChecked);
    console.log(isChecked, "isChecked");

    const value = isChecked ? 1 : 0;
    ths.resetDispute(value);
    ths.resetCounter();
  };

  return (
    <div className="parentContainer">
      <div className="tableContainer theFixedTableClass m-0 pb-0 position-relative d-flex gap-3 justify-content-end align-items-center">
        <input
        id="idMarque"
          type="checkbox"
          name="marque"
          checked={checked}
          onChange={handleCheckboxChange}
        />{" "}
        <label htmlFor="idMarque">Marque</label>
        <input
        id="idDespute"
          type="checkbox"
          name="despute"
          checked={desputeChecked}
          onChange={handleCheckboxDesputeChange}
        />{" "}

        <label htmlFor="idDespute">Dispute</label>
        
      </div>
    </div>
  );
};
export default MarqueFilterComponent;
